'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getCurrentEntity;

var _getSelectedBlock = require('./getSelectedBlock');

var _getSelectedBlock2 = _interopRequireDefault(_getSelectedBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getCurrentEntity(editorState) {
    var entity = void 0;
    var selection = editorState.getSelection();
    var start = selection.getStartOffset();
    var end = selection.getEndOffset();
    if (start === end && start === 0) {
        end = -1;
    } else if (start === end) {
        start = start - 1;
    }
    var block = (0, _getSelectedBlock2["default"])(editorState);
    for (var i = start; i < end; i++) {
        var currentEntity = block.getEntityAt(i);
        if (!currentEntity) {
            entity = undefined;
            break;
        }
        if (i === start) {
            entity = currentEntity;
        } else {
            if (entity !== currentEntity) {
                entity = undefined;
                break;
            }
        }
    }
    return entity;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-utils@0.1.0@rc-editor-utils/lib/getCurrentEntity.js
// module id = 118
// module chunks = 0 1 2